import AquaaActionTypes from "../../constants/Applications/aquaa-actionTypes";

const initialState = { 
  aquaaAccounts: [],
  aquaaAgents:[],
  aquaaChannels:[],
  aquaaLanguages:[],
  aquaaLocations:[],
  aquaaValidFrom:[],
  aquaaAWS:[],
  evaluationData:[],
  savedEvaluationsData:[],
  submittedEvaluationsData:[],
  savedevaluationFormData:[],
  saveEvaluationData:[],
  aquaaNonASDAccounts:[],
  aquaaNonASDChannels:[],
  aquaaNonASDLocations:[],
  aquaaNonASDLanguages:[],
  aquaaNonASDAgents:[],
  additionalReciepients:[],
  nonASDEvaluationFormData:[],
  agentEvaluationsData:[],
  aquaaAdminAccountsData:[],
  aquaaAdminAccountsTableData:[],
  aquaaAdminChannelsData:[],
  aquaaAdminContactTypeTableData:[],
  aquaaQuestionAssessmentsData:[],
  aquaaAdminQuestionsTableData:[],
  aquaaMappingAccounts:[],
  aquaaMappingContacttypeForms:[],
  aquaaMappingCountries:[],
  aquaaMappingSections:[],
  aquaaMappingQuestions:[],
  aquaaMappingParameterType:[],
  aquaaEvaluationsDeleteData:[],
  aquaaValidateTicketNo:[],
  aquaaIcedAgents:[],
  aquaaIcedAccounts:[],
  aquaaIcedTableData:[],
  aquaaIcedL1Category:[],
  aquaaIcedL2Category:[],
  aquaaIcedEvaluationsData:[],
  accountEvaluatorAccounts:[],
  accountEvaluatorEvaluators:[],
  accountEvaluatorTableData:[],
  accountEvaluatorUsersData:[],
  icedReportsAccounts:[],
  icedMasterData:[],
  icedTableData:[],
  recommendationsTableData:[],
  trainerTableData:[],
  recommendationsDropdownData:[]


};


const fetchAquaaAccountsData = (state, action) => {      
    return {
      ...state,
    };
  };
  
const updateAquaaAccountsData = (state, action) => {
return { ...state, aquaaAccounts: action.payload };
};

const fetchAquaaAgentsData = (state, action) => {      
  return {
    ...state,
  };
};

const updateAquaaAgentssData = (state, action) => {
return { ...state, aquaaAgents: action.payload };
};





const aquaaReducer = (state = initialState, action) => {
    switch (action.type) {
      case AquaaActionTypes.GET_AQUAA_ACCOUNTS_DATA:
        return fetchAquaaAccountsData(state, action);
      case AquaaActionTypes.AQUAA_ACCOUNTS_DATA:
        return updateAquaaAccountsData(state, action); 
      case AquaaActionTypes.GET_AQUAA_AGENT_DATA:
          return fetchAquaaAgentsData(state, action);
      case AquaaActionTypes.AQUAA_AGENTS_DATA:
          return updateAquaaAgentssData(state, action);     
      case AquaaActionTypes.GET_AQUAA_CHANNELS_DATA:
      case AquaaActionTypes.GET_AQUAA_LANGUAGES_DATA:
      case AquaaActionTypes.GET_AQUAA_LOCATIONS_DATA:
      case AquaaActionTypes.GET_AQUAA_VALIDFROM_DATA:
      case AquaaActionTypes.GET_AQUAA_AWS_DATA:
      case AquaaActionTypes.GET_EVALUATION_FORM_DATA:
      case AquaaActionTypes.GET_SAVED_EVALUATIONS_DATA:
      case AquaaActionTypes.GET_SUBMITTED_EVALUATIONS_DATA:
      case AquaaActionTypes.GET_SAVED_EVALUATION_FORM_DATA:
      case AquaaActionTypes.GET_AQUAA_NONASD_ACCOUNTS_DATA:
      case AquaaActionTypes.GET_AQUAA_NONASD_CHANNELS_DATA:
      case AquaaActionTypes.GET_AQUAA_NONASD_LOCATIONS_DATA:
      case AquaaActionTypes.GET_AQUAA_NONASD_LANGUAGES_DATA:
      case AquaaActionTypes.GET_AQUAA_NONASD_AGENTS_DATA:
      case AquaaActionTypes.GET_ADDITIONAL_RECIPIENTS:
      case AquaaActionTypes.GET_NONASD_EVALUATION_FORM_DATA:
      case AquaaActionTypes.GET_AGENT_EVALUATIONS_DATA:
      case AquaaActionTypes.GET_AQUAA_ADMIN_ACCOUNTS_DATA:
      case AquaaActionTypes.GET_AQUAA_ADMIN_ACCOUNTS_TABLE_DATA:
      case AquaaActionTypes.GET_AQUAA_ADMIN_CHANNELS_DATA:
      case AquaaActionTypes.GET_AQUAA_ADMIN_CONTACTTYPE_TABLE_DATA:
      case AquaaActionTypes.GET_AQUAA_QUESTION_ASSESSMENTS_DATA:
      case AquaaActionTypes.GET_AQUAA_ADMIN_QUESTIONS_TABLE_DATA:
      case AquaaActionTypes.GET_AQUAA_MAPPING_ACCOUNTS:
      case AquaaActionTypes.GET_AQUAA_MAPPING_CONTACTTYPE_FORMS:
      case AquaaActionTypes.GET_AQUAA_MAPPING_COUNTRIES:
      case AquaaActionTypes.GET_AQUAA_MAPPING_SECTIONS:
      case AquaaActionTypes.GET_AQUAA_MAPPING_QUESTIONS:
      case AquaaActionTypes.GET_AQUAA_MAPPING_PARAMETERTYPE:
      case AquaaActionTypes.GET_AQUAA_EVALUATIONS_DELETE:
      case AquaaActionTypes.GET_AQUAA_VALIDATE_TICKET_NO:
      case AquaaActionTypes.GET_AQUAA_ICED_AGENTS:
      case AquaaActionTypes.GET_AQUAA_ICED_ACCOUNTS:
      case AquaaActionTypes.GET_AQUAA_ICED_TABLE_DATA:
      case AquaaActionTypes.GET_AQUAA_ICED_L1_CATEGORY:
      case AquaaActionTypes.GET_AQUAA_ICED_L2_CATEGORY:
      case AquaaActionTypes.GET_AQUAA_ICED_EVALUATIONS_DATA:
      case AquaaActionTypes.GET_ACCOUNT_EVALUATOR_ACCOUNTS_DATA:
      case AquaaActionTypes.GET_ACCOUNT_EVALUATOR_EVALUATORS_DATA:
      case AquaaActionTypes.GET_ACCOUNT_EVALUATOR_TABLE_DATA:
      case AquaaActionTypes.GET_ACCOUNT_EVALUATOR_USERS_DATA:
      case AquaaActionTypes.GET_ICED_REPORTS_ACCOUNTS:
      case AquaaActionTypes.GET_ICED_MASTER_DATA:
      case AquaaActionTypes.GET_ICED_TABLE_DATA:
      case AquaaActionTypes.GET_RECOMMENDATIONS_TABLE_DATA:
      case AquaaActionTypes.GET_TRAINER_TABLE_DATA:
      case AquaaActionTypes.GET_RECOMMENDATIONS_DROPDOWN_DATA:






          return { ...state };
      case AquaaActionTypes.SAVE_EVALUATION_DATA:
           return { ...state, saveEvaluationData: action.payload };
      case AquaaActionTypes.AQUAA_CHANNELS_DATA:
          return { ...state, aquaaChannels: action.payload };
      case AquaaActionTypes.AQUAA_LANGUAGES_DATA:
          return { ...state, aquaaLanguages: action.payload };
      case AquaaActionTypes.AQUAA_LOCATIONS_DATA:
          return { ...state, aquaaLocations: action.payload };
      case AquaaActionTypes.AQUAA_VALIDFROM_DATA:
          return { ...state, aquaaValidFrom: action.payload };
      case AquaaActionTypes.AQUAA_AWS_DATA:
          return { ...state, aquaaAWS: action.payload };
      case AquaaActionTypes.EVALUATION_FORM_DATA:
          return { ...state, evaluationData: action.payload };
      case AquaaActionTypes.SAVED_EVALUATIONS_DATA:
          return { ...state, savedEvaluationsData: action.payload };
      case AquaaActionTypes.SUBMITTED_EVALUATIONS_DATA:
          return { ...state, submittedEvaluationsData: action.payload };
      case AquaaActionTypes.SAVED_EVALUATION_FORM_DATA:
          return { ...state, savedevaluationFormData: action.payload };
      case AquaaActionTypes.AQUAA_NONASD_ACCOUNTS_DATA:
          return { ...state, aquaaNonASDAccounts: action.payload };
      case AquaaActionTypes.AQUAA_NONASD_CHANNELS_DATA:
          return { ...state, aquaaNonASDChannels: action.payload };
      case AquaaActionTypes.AQUAA_NONASD_LOCATIONS_DATA:
          return { ...state, aquaaNonASDLocations: action.payload };
      case AquaaActionTypes.AQUAA_NONASD_LANGUAGES_DATA:
          return { ...state, aquaaNonASDLanguages: action.payload };
      case AquaaActionTypes.AQUAA_NONASD_AGENTS_DATA:
          return { ...state, aquaaNonASDAgents: action.payload };
      case AquaaActionTypes.ADDITIONAL_RECIPIENTS:
          return { ...state, additionalReciepients: action.payload };
      case AquaaActionTypes.NONASD_EVALUATION_FORM_DATA:
          return { ...state, nonASDEvaluationFormData: action.payload };
      case AquaaActionTypes.AGENT_EVALUATIONS_DATA:
          return { ...state, agentEvaluationsData: action.payload };
      case AquaaActionTypes.AQUAA_ADMIN_ACCOUNTS_DATA:
          return { ...state, aquaaAdminAccountsData: action.payload };
      case AquaaActionTypes.AQUAA_ADMIN_ACCOUNTS_TABLE_DATA:
          return { ...state, aquaaAdminAccountsTableData: action.payload };
      case AquaaActionTypes.AQUAA_ADMIN_CHANNELS_DATA:
          return { ...state, aquaaAdminChannelsData: action.payload };
      case AquaaActionTypes.AQUAA_ADMIN_CONTACTTYPE_TABLE_DATA:
          return { ...state, aquaaAdminContactTypeTableData: action.payload };
      case AquaaActionTypes.AQUAA_QUESTION_ASSESSMENTS_DATA:
          return { ...state, aquaaQuestionAssessmentsData: action.payload };
      case AquaaActionTypes.AQUAA_ADMIN_QUESTIONS_TABLE_DATA:
          return { ...state, aquaaAdminQuestionsTableData: action.payload };
      case AquaaActionTypes.AQUAA_MAPPING_ACCOUNTS:
          return { ...state, aquaaMappingAccounts: action.payload };
      case AquaaActionTypes.AQUAA_MAPPING_CONTACTTYPE_FORMS:
          return { ...state, aquaaMappingContacttypeForms: action.payload };
      case AquaaActionTypes.AQUAA_MAPPING_COUNTRIES:
          return { ...state, aquaaMappingCountries: action.payload };
      case AquaaActionTypes.AQUAA_MAPPING_SECTIONS:
          return { ...state, aquaaMappingSections: action.payload };
      case AquaaActionTypes.AQUAA_MAPPING_QUESTIONS:
          return { ...state, aquaaMappingQuestions: action.payload };
      case AquaaActionTypes.AQUAA_MAPPING_PARAMETERTYPE:
          return { ...state, aquaaMappingParameterType: action.payload };
      case AquaaActionTypes.AQUAA_EVALUATIONS_DELETE:
          return { ...state, aquaaEvaluationsDeleteData: action.payload };
      case AquaaActionTypes.AQUAA_VALIDATE_TICKET_NO:
          return { ...state, aquaaValidateTicketNo: action.payload };
          case AquaaActionTypes.AQUAA_ICED_AGENTS:
          return { ...state, aquaaIcedAgents: action.payload };
          case AquaaActionTypes.AQUAA_ICED_ACCOUNTS:
          return { ...state, aquaaIcedAccounts: action.payload };
          case AquaaActionTypes.AQUAA_ICED_TABLE_DATA:
          return { ...state, aquaaIcedTableData: action.payload };
          case AquaaActionTypes.AQUAA_ICED_L1_CATEGORY:
          return { ...state, aquaaIcedL1Category: action.payload };
          case AquaaActionTypes.AQUAA_ICED_L2_CATEGORY:
          return { ...state, aquaaIcedL2Category: action.payload };
          case AquaaActionTypes.AQUAA_ICED_EVALUATIONS_DATA:
          return { ...state, aquaaIcedEvaluationsData: action.payload };
          case AquaaActionTypes.ACCOUNT_EVALUATOR_ACCOUNTS_DATA:
          return { ...state, accountEvaluatorAccounts: action.payload };
          case AquaaActionTypes.ACCOUNT_EVALUATOR_EVALUATORS_DATA:
          return { ...state, accountEvaluatorEvaluators: action.payload };
          case AquaaActionTypes.ACCOUNT_EVALUATOR_TABLE_DATA:
          return { ...state, accountEvaluatorTableData: action.payload };
          case AquaaActionTypes.ACCOUNT_EVALUATOR_USERS_DATA:
          return { ...state, accountEvaluatorUsersData: action.payload };
          case AquaaActionTypes.ICED_REPORTS_ACCOUNTS:
          return { ...state, icedReportsAccounts: action.payload };
          case AquaaActionTypes.ICED_MASTER_DATA:
          return { ...state, icedMasterData: action.payload };
          case AquaaActionTypes.ICED_TABLE_DATA:
          return { ...state, icedTableData: action.payload };
          case AquaaActionTypes.RECOMMENDATIONS_TABLE_DATA:
          return { ...state, recommendationsTableData: action.payload };
          case AquaaActionTypes.TRAINER_TABLE_DATA:
          return { ...state, trainerTableData: action.payload };
          case AquaaActionTypes.RECOMMENDATIONS_DROPDOWN_DATA:
          return { ...state, recommendationsDropdownData: action.payload };
      default:
        return state;
    }
  };
  
  export default aquaaReducer;